import { useTrackPageLoad as useBareTrackPageLoad } from '@calendly/segment'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { identifyOptionsSelector } from 'selectors/segment'

export const useTrackPageLoad = () => {
  const { pathname } = useLocation()
  const identifyOptions = useSelector(identifyOptionsSelector)

  useBareTrackPageLoad(pathname, identifyOptions)
}
